import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, useParams } from "react-router-dom";
import { createEmailTemplate, createPackageApi, createShippingAPi, getPackageSizeApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const AddShipCharges = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedPackage } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;
    // const { id } = useParams();

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const src = URL.createObjectURL(e.target.files[0]);
    //         setImagePreview(src);
    //     }
    // };

    // const handleRemoveImage = () => {
    //     setImagePreview(null);
    // };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        console.log("Editor content:", editorContent);
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];


    const [intCharges, setIntCharges] = useState('');
    const [locCharges, setLocCharges] = useState('');
    const [taxes, setTaxes] = useState('');
    const [sizeHeight, setSizeHeight] = useState('');
    const [sizeWeight, setSizeWeight] = useState('');
    const [discount, setDiscount] = useState('');
    const [loading, setLoading] = useState(false)

    const [selectedUnit, setSelectedUnit] = useState("AIR");


    const [subject, setSubject] = useState('');






    // const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [packageId, setPackageId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');

    const [ShipmentCharges, setShipmentCharges] = useState([]);





    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)


        // if (!value || value === '<p><br></p>') {
        //     toast.error("Message is required");
        //     return;
        // }

        // if (!imagePreview) {
        //     toast.error("Image is required");
        //     return;
        // }




        // const formData = new FormData();
        // formData.append('size_name', sizeName);
        // formData.append('size_length', sizeLength);
        // formData.append('size_width', sizeWidth);
        // formData.append('size_height', sizeHeight);
        // formData.append('size_weight', sizeWeight);
        // formData.append('discount', discount);
        // formData.append('inch', selectedUnit === "Inch" ? true : false);



        // formData.append('from', fromCountry);
        // formData.append('to', toCountry);
        // formData.append('id', packageId);


        // if (mailImage) {
        //     formData.append('icon_url', mailImage);
        // }

        const payloadData = {
            Order_charges_type: "SHIPMENT",
            international_courier_charge: Number(intCharges),
            local_delivery_charge: Number(locCharges),
            shipping_charges_type: selectedUnit,
            taxes: Number(taxes),
            id: ""





        }

        try {
            const res = await createShippingAPi(payloadData);
            console.log('Success:', res);
            toast.success(res.message || "Success")
            navigate("/shipment-charges")


        } catch (err) {
            toast.error(err || "Something went wrong")

            console.error('Error:', err);
        }

        finally{
            setLoading(false)
        }


    };

    //Insert var|

    // const insertVariable = (e) => {
    //     const variable = e.target.value;

    //     if (!variable || !quillRef.current) return;

    //     const editor = quillRef.current.getEditor();
    //     const cursorPosition = editor.getSelection()?.index || 0;
    //     editor.insertText(cursorPosition, `{${variable}}`);
    //     editor.setSelection(cursorPosition + variable.length + 2);
    //     e.target.value = '';
    // };

    console.log("Package", selectedPackage)


    useEffect(() => {
        if (selectedPackage) {

            // setSizeName(selectedPackage?.size_name || '')
            // setSizeLength(selectedPackage?.size_length || '')
            // setSizeWidth(selectedPackage?.size_width || '')
            setSizeHeight(selectedPackage?.size_height || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setDiscount(selectedPackage?.discount || '')
            setSelectedUnit(selectedPackage?.inch ? "Inch" : "Feet" || '')
            setPackageId(selectedPackage?.id || '')


            // setEmailId(selectedEmailTemplate?.id || '')




            if (selectedPackage?.icon_url) {
                setImagePreview(selectedPackage.icon_url);
                const imageName = selectedPackage.icon_url
                setImageName(imageName);
                setMailImage(selectedPackage?.icon_url)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }



        }

        return () => {

            dispatch(clearSelectedPackage());
        };
    }, [selectedPackage, dispatch]);

    // console.log(mailImage)
    function getTotalFieldValue(info) {
        const local_delivery_charge = info?.local_delivery_charge
            ? info?.local_delivery_charge
            : 0;
        const international_courier_charge = info?.international_courier_charge
            ? info?.international_courier_charge
            : 0;
        const human_resource_charge = info?.human_resource_charge
            ? info?.human_resource_charge
            : 0;
        const taxes = info?.taxes ? info?.taxes : 0;
        let grandTotal = local_delivery_charge + international_courier_charge;
        if (info?.Order_charges_type === "ECOM") {
            grandTotal += human_resource_charge;
        }
        const taxAmount = (grandTotal * taxes) / 100;
        return taxAmount + grandTotal;
    }


    function calculateShipmentAmountTotal(shipType, orderType, value = 0) {
        const charges = ShipmentCharges.find(
            (el) =>
                el.shipping_charges_type === shipType &&
                el.Order_charges_type === orderType
        );
        const amountWithTax = getTotalFieldValue({
            ...charges,
            Order_charges_type: orderType,
        });
        let grandTotal = amountWithTax * value;
        if (discount) {
            const discountAmount = (grandTotal * discount) / 100;
            grandTotal = grandTotal - discountAmount;
        }
        return grandTotal.toFixed(2);
    }

    function getTotalVal(taxPercent, internationCharge, localCharge) {
        const international = Number(internationCharge);
        const local = Number(localCharge);
        const tax = Number(taxPercent);

        const subtotal = international + local;
        const taxAmount = (subtotal * tax) / 100;
        const total = subtotal + taxAmount;

        return Number(total.toFixed(2)); // Optional: rounds to 2 decimal places
    }

    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };

    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Add Shipment Charges</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>

                            <div className="row">
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='intCharges'>
                                        International Charges:
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeName'
                                        placeholder='Enter Applicable International Charges'
                                        value={intCharges}
                                        // onChange={(e) => setIntCharges(e.target.value)}
                                        onChange={(e) => handleNumericInput(e, setIntCharges)}
                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeLength'>
                                        Local Charges:
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeLength'
                                        placeholder='Enter Applicable Local Charges'
                                        value={locCharges}
                                        // onChange={(e) => setLocCharges(e.target.value)}
                                        onChange={(e) => handleNumericInput(e, setLocCharges)}
                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeWidth'>
                                        Taxes (%):
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeWidth'
                                        placeholder='Enter Applicable Tax Percent'
                                        value={taxes}
                                        // onChange={(e) => setTaxes(e.target.value)}
                                        onChange={(e) => handleNumericInput(e, setTaxes)}
                                    />
                                </div>
                            </div>








                            <div className="row">

                                <div className="col-md-6 col-12">

                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeName'>

                                        Shipment Type
                                    </label>

                                    <div className="dropdown">
                                        <button
                                            className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {selectedUnit}
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("AIR")}
                                                >
                                                    AIR
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"

                                                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                    onClick={() => setSelectedUnit("SHIP")}
                                                >
                                                    SHIP
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                            </div>

                            <div className="row">




                                <div className="col-12 col-md-3 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='ecomAir'>
                                        Total:
                                    </label>
                                    <input
                                        disabled

                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='ecomAir'

                                        placeholder='Auto-calculated'
                                        value={getTotalVal(taxes, intCharges, locCharges)}
                                        readOnly
                                    />
                                </div>
                            </div>



                            {/* <div className="row">




                                <div className="col-12 col-md-6">
                                    <label className='form-label fw-bold text-neutral-900'>
                                        Package Box Icon
                                    </label>
                                    <div className='upload-image-wrapper'>
                                        {imagePreview ? (
                                            <div className='uploaded-msg-wrapper h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-success-50 d-flex justify-content-between align-items-center px-3'>
                                                <div>
                                                    <p className='mb-1 fw-semibold text-success-700'>Image uploaded successfully</p>
                                                    <p className='mb-0 text-sm text-neutral-700'>{imageName}</p>
                                                </div>
                                                <button
                                                    type='button'
                                                    className='btn btn-sm btn-danger ms-3'
                                                    onClick={handleRemoveImage}
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <label
                                                className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 cursor-pointer'
                                                htmlFor='upload-file'
                                            >
                                                <iconify-icon
                                                    icon='solar:camera-outline'
                                                    className='text-xl text-secondary-light'
                                                ></iconify-icon>
                                                <span className='fw-semibold text-secondary-light'>
                                                    Upload
                                                </span>
                                                <input
                                                    id='upload-file'
                                                    type='file'
                                                    hidden
                                                    accept='image/*'
                                                    onChange={handleFileChange}
                                                />
                                            </label>
                                        )}
                                    </div>
                                </div>



                            </div> */}


                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2' disabled={loading && true}>
                            {loading ? "Submitting..." : "Submit"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default AddShipCharges;
